import { view } from '@yola/ws-sdk';
import { DESKTOP_BREAKPOINT } from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import getResponsiveLineHeight from './get-responsive-line-height';
import forceRestyleDecorationTags from './force-restyle-decoration-tags';
import getFontSizeAutofill from './get-font-size-autofill';
import stripAutofillAtBreakpoint from './strip-autofill-at-breakpoint';

const changeFontSize = (modifier, focusElements, breakpoint = DESKTOP_BREAKPOINT) => {
  const fontSize = Number(modifier);
  const lineHeight = getResponsiveLineHeight(fontSize, breakpoint);
  const autofill = getFontSizeAutofill(fontSize, breakpoint);

  focusElements.forEach((node) => {
    const currentClass = node.getAttribute('class') || '';
    const cleanedClass = autofill
      ? currentClass
      : stripAutofillAtBreakpoint(currentClass, breakpoint);

    const newClass = view.helpers.getPatchedResponsiveClass({
      currentClass: cleanedClass,
      className: 'text',
      value: `[${fontSize}px]/[${lineHeight}px]`,
      breakpoint,
      autofill,
    });

    node.setAttribute('class', newClass);

    forceRestyleDecorationTags(node);
  });
};

export default changeFontSize;
